import { OverlayRoot, type OverlayRootProps } from '../Overlay';
import { PopoverContext } from '../Popover';
import { menuPopoverProps } from './MenuPopover';

export type MenuRootProps = OverlayRootProps;

export function MenuRoot(props: MenuRootProps) {
    return (
        <OverlayRoot {...props}>
            <PopoverContext.Provider value={menuPopoverProps}>
                {props.children}
            </PopoverContext.Provider>
        </OverlayRoot>
    );
}
